// extracted by mini-css-extract-plugin
module.exports = {"h2":"typography__h2___1U0pM"};